import React, { createContext, useContext, useState } from "react";

const GuideContext = createContext(null);

export function GuideProvider({ children }) {
  const [session, setSession] = useState(null);
  const openGuide = (next) => setSession({ minimized: false, ...next });
  const closeGuide = () => setSession(null);
  const minimizeGuide = () => setSession((current) => (current ? { ...current, minimized: true } : current));
  const restoreGuide = () => setSession((current) => (current ? { ...current, minimized: false } : current));
  return (
    <GuideContext.Provider value={{ session, openGuide, closeGuide, minimizeGuide, restoreGuide }}>
      {children}
    </GuideContext.Provider>
  );
}

export function useGuide() {
  return useContext(GuideContext) || {
    session: null,
    openGuide() {},
    closeGuide() {},
    minimizeGuide() {},
    restoreGuide() {},
  };
}
